// Add your custom JS here.

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      document.getElementById("main-nav").classList.add("fixed-top");
      // add padding top to show content behind navbar
      //navbar_height = document.querySelector('.navbar').offsetHeight;
      //document.body.style.paddingTop = navbar_height + 'px';
    } else {
      document.getElementById("main-nav").classList.remove("fixed-top");
      // remove padding top from body
      document.body.style.paddingTop = "0";
    }
  });
});
// DOMContentLoaded  end

jQuery(document).ready(function ($) {
  $("#navbarNavOffcanvas").on("hidden.bs.collapse", function () {
    $("#navbarNavOffcanvas").closest(".offcanvas").removeClass("show");
  });
  $("#navbarNavOffcanvas").on("show.bs.collapse", function () {
    $("#navbarNavOffcanvas").closest(".offcanvas").addClass("show");
  });
});


jQuery(document).ready(function($) {

  // Scrolling for anchor links in within the same page
  jQuery('a[href*="#"]:not([href="#"])').click(function(){
      _hash = this.hash;
      _scroll_it( _hash );
  });

  // scrolling for anchor links coming from a different page
  var _hash = window.location.hash;
  if( _hash.length > 0 ){     
      window.scrollTo(0, 0);
      
      setTimeout( function() { 
          _scroll_it( _hash );
      }, 500 );       
  }
  
  function _scroll_it( _hash ){
      jQuery('html,body').animate({
          scrollTop: jQuery( _hash ).offset().top-60
      }, 500 );
  }

});

jQuery(document).ready(function($) {
  
  function normalizeSlideHeights() {
    $('.carousel').each(function(){
      var items = $('.carousel-item', this);
      // reset the height
      items.css('min-height', 0);
      // set the height
      var maxHeight = Math.max.apply(null, 
          items.map(function(){
              return $(this).outerHeight()}).get() );
      items.css('min-height', maxHeight + 'px');
    })
  }

  $(window).on(
    'load resize orientationchange', 
    normalizeSlideHeights);
});